import { useState, FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search } from 'lucide-react'

export function BlogSearch() {
  const [searchQuery, setSearchQuery] = useState('')
  const navigate = useNavigate()

  const handleSearch = (e: FormEvent) => {
    e.preventDefault()
    if (searchQuery.trim()) {
      navigate(`/blog?search=${encodeURIComponent(searchQuery.trim())}`)
    } else {
      navigate('/blog')
    }
  }

  return (
    <div className="w-full max-w-md mx-auto">
      <form onSubmit={handleSearch} className="flex items-center">
        <div className="relative w-full group">
          <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-primary/30 opacity-0 group-hover:opacity-100 rounded-full blur-sm transition-opacity -z-10"></div>
          <input
            type="text"
            className="w-full pl-6 pr-28 py-4 border border-border/30 rounded-full focus:outline-none focus:ring-2 focus:ring-primary/50 bg-background/50 backdrop-blur-sm shadow-sm transition-all group-hover:border-primary/30"
            placeholder="Search articles..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button
            type="submit"
            className="absolute right-1.5 inset-y-1.5 bg-primary hover:bg-primary/90 text-primary-foreground font-medium rounded-full px-6 py-2 text-sm transition-all duration-300 hover:shadow-md hover:shadow-primary/20 flex items-center gap-2 group-hover:translate-x-0.5"
          >
            <span>Search</span>
            <Search className="h-4 w-4" />
          </button>
        </div>
      </form>
    </div>
  )
}